import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import * as Services from '../../../sdk/services';
import {
  PESSOAS_LISTAR_BEGIN, PESSOAS_LISTAR_DISMISS_ERROR, PESSOAS_LISTAR_FAILURE, PESSOAS_LISTAR_SUCCESS
} from './constants';

export function listar() {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: PESSOAS_LISTAR_BEGIN,
  };
}

export function dismissListarError() {
  return {
    type: PESSOAS_LISTAR_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on PESSOAS_LISTAR_BEGIN actions
export function* doListar() {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  // const UsuarioApi = new Services['UsuarioApi'];
  const PessoaApi = new Services['PessoaApi']();
  try {
    // const { data } = yield UsuarioApi.find().then(ret => {
    //   return { data: ret };
    // });
    // res = data;
    res = yield PessoaApi.find({
      include: ['UsuarioPerfil'],
      order: 'nomeCompleto ASC',
    });
  } catch (err) {
    yield put({
      type: PESSOAS_LISTAR_FAILURE,
      data: { error: err },
    });
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: PESSOAS_LISTAR_SUCCESS,
    data: res,
  });
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchListar() {
  yield takeLatest(PESSOAS_LISTAR_BEGIN, doListar);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case PESSOAS_LISTAR_BEGIN:
      return {
        ...state,
        registros: [],
        listarPending: true,
        listarError: null,
      };

    case PESSOAS_LISTAR_SUCCESS:
      return {
        ...state,
        registros: action.data,
        listarPending: false,
        listarError: null,
      };

    case PESSOAS_LISTAR_FAILURE:
      return {
        ...state,
        listarPending: false,
        listarError: action.data.error,
      };

    case PESSOAS_LISTAR_DISMISS_ERROR:
      return {
        ...state,
        listarError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/pessoas/redux/listar.js